module.exports = __webpack_public_path__ + "static/media/placeholder-image.9aeca117.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/placeholder-image.png
// module id = 108
// module chunks = 0